// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3baCH","vLegacy":"SelectSecondary_vLegacy__26vtz","error":"SelectSecondary_error__3xcMs","disabled":"SelectSecondary_disabled__3_qIM"};